import { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { Link, useNavigate } from "react-router-dom";
//prime react
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { BreadCrumb } from "primereact/breadcrumb";
// components
import Panel from "../../../components/panel/panel";
import ModalCreateAccessGroup from "./ModalCreateAccessGroup";
import ExportTable from "../../../components/button/ExportButton";
// services
import { getRole } from "../../../services/GlobalRoles/getRoles";
//context
import { useAppContext } from "../../../context/AppContext";
import usePermission from "../../../hooks/usePermission";
import { confirmDialog } from "primereact/confirmdialog";
import { deleteAccessGroup } from "../../../services/Settings/AccessGroup/deleteAccessGroup";
import { toast } from "react-toastify";

const AccessGroups = () => {
  usePermission("132"); // Visualizar Grupos de Acesso
  const { permissions } = useAppContext();
  const items = [
    {
      template: () => (
        <Link to={`/settings/accessGroups`} className="p-breadcrumb-link">
          Grupos de Acesso
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"#"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const [visibleModal, setVisibleModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [tableToExport, setTableToExport] = useState(null);

  const columns = [{ field: "name", header: "Grupo" }];
  const handleCloseModal = () => {
    setVisibleModal(false);
  };

  const navigate = useNavigate();

  const nextPage = (rowData) => {
    navigate("seeEdit", { state: { rowData } });
  };
  const nextPageTypes = (rowData) => {
    navigate("editTypesRegistration", { state: { rowData } });
  };

  const handleDelete = (data) => {
    confirmDialog({
      message: `Deseja excluir o grupo de acesso: ${data.name}?`,
      header: "Confirmação",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => handleDeleteAccess(data.id),
    });
  };

  const handleDeleteAccess = async (data) => {
    const notification = toast.loading("Por favor aguarde...");
    try {
      await deleteAccessGroup(data);
      await refetch();

      toast.update(notification, {
        render: "Grupo de Acesso Deletado com Sucesso",
        autoClose: 2000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      console.log(error);
      const errorMessage =
        error.message || "Houve um erro ao excluir o grupo de acesso!";
      refetch();

      toast.update(notification, {
        render: errorMessage,
        autoClose: 3000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    }
  };

  const onGlobalFilterChange = (e) => {
    setGlobalFilterValue(e.target.value);
  };

  const exportColumns = columns.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const {
    data: roles,
    refetch,
    isLoading: isLoadingGroup,
  } = useQuery({
    queryKey: ["roles"],
    queryFn: () => getRole(),
    enabled: !!permissions?.includes("132"), //Visualizar Grupos de Acesso
  });

  useEffect(() => {
    if (roles) {
      // console.log(roles);
      const dataWithoutIds = roles.map((t) => ({
        ID: t.id,
        GrupoAcesso: t.name,
        CriadoEm: t.created_at,
        AtualizadoEm: t.updated_at,
      }));
      // console.log("sem ids", dataWithoutIds);
      setTableToExport(dataWithoutIds);
    }
  }, [roles]);

  return (
    <>
      <div className="d-flex justify-content-between">
        <div className="col-xl-4 col-md-6">
          <BreadCrumb model={items} home={home} className="breadCrumb" />
        </div>
        {permissions?.includes("133") && ( //Cadastrar Grupo de Acesso
          <div className="col-xl-2 col-md-6">
            <Button
              rounded
              loading={isLoadingGroup}
              icon="fa fa-plus"
              label="Novo Grupo"
              onClick={() => setVisibleModal(true)}
              className="p-inputtext-sm me-2 m-auto w-100"
            />
          </div>
        )}
      </div>

      <Panel mainCss="mt-4" title="Grupos de Acesso">
        {isLoadingGroup ? (
          <Skeleton variant="rect" width="100%" height={300} />
        ) : (
          <div>
            <hr className="my-4" />
            <ExportTable
              tableData={tableToExport}
              exportColumns={exportColumns}
              tabelaKey="Grupos de Acesso"
              onGlobalFilterChange={onGlobalFilterChange}
              globalFilterValue={globalFilterValue}
            />
            <DataTable
              stripedRows
              showGridlines
              sortMode="multiple"
              selectionMode="single"
              value={roles}
              paginator
              rows={10}
              sortableColumns={false}
              rowsPerPageOptions={[10, 25, 50]}
              // footerColumnGroup={footerGroup}
              globalFilter={globalFilterValue}
              emptyMessage="Nenhuma Informação foi encontrada."
              tableStyle={{
                minWidth: "1rem",
                fontSize: "0.8rem",
                border: "0.8rem",
              }}
            >
              {columns.map((col) => (
                <Column
                  sortable
                  key={col.field}
                  field={col.field}
                  header={col.header}
                />
              ))}
              {permissions &&
                permissions.includes("132") && ( //Visualizar Grupo de Acesso
                  <Column
                    header="Acessos"
                    body={(rowData) => (
                      <div className="text-center">
                        <button
                          className="btn btn-warning btn-btn-sm"
                          onClick={() => nextPage(rowData)}
                        >
                          <i className="fa-solid fa-pen-to-square"></i>
                        </button>
                      </div>
                    )}
                  />
                )}
              {permissions &&
                permissions.includes("134") && ( //Editar Tipo de Cadastros por Grupo de Acesso
                  <Column
                    header="Tipo de Cadastro"
                    body={(rowData) => (
                      <div className="text-center">
                        <button
                          className="btn btn-warning btn-btn-sm"
                          onClick={() => nextPageTypes(rowData)}
                        >
                          <i className="fa-solid fa-pen-to-square"></i>
                        </button>
                      </div>
                    )}
                  />
                )}
              {permissions &&
                permissions.includes("135") && ( //Deletar Permissão de Acesso
                  <Column
                    header="Excluir"
                    body={(rowData) => (
                      <div className="text-center">
                        <button
                          className="btn btn-danger btn-btn-sm"
                          onClick={() => handleDelete(rowData)}
                        >
                          <i className="fa-solid fa-trash"></i>
                        </button>
                      </div>
                    )}
                  />
                )}
            </DataTable>
          </div>
        )}
      </Panel>
      <ModalCreateAccessGroup
        visible={visibleModal}
        handleCloseModal={handleCloseModal}
        setVisible={setVisibleModal}
        refresh={refetch}
        loading={setLoading}
      />
    </>
  );
};

export default AccessGroups;
